import {createSlice} from "@reduxjs/toolkit";

const initialDriverVehiclesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  drivervehicleForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const drivervehiclesSlice = createSlice({
  name: "drivervehicles",
  initialState: initialDriverVehiclesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getDriverVehicleById
    drivervehicleFetched: (state, action) => {
      state.actionsLoading = false;
      state.drivervehicleForEdit = action.payload.drivervehicleForEdit;
      state.error = null;
    },
    // findDriverVehicles
    drivervehiclesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createDriverVehicle
    drivervehicleCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.drivervehicle);
    },
    // updateDriverVehicle
    drivervehicleUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.drivervehicle.id) {
          return action.payload.drivervehicle;
        }
        return entity;
      });
    },
    // deleteDriverVehicle
    drivervehicleDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteDriverVehicles
    drivervehiclesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // drivervehiclesUpdateState
    drivervehiclesStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
